/** Matches promotions RebateStatusKind  */
export const RebateStatus = {
  Active: "Active",
  Expired: "Expired",
  Inactive: "Inactive",
  Upcoming: "Upcoming",
  Previewing: "Previewing",
} as const;
export type RebateStatus = (typeof RebateStatus)[keyof typeof RebateStatus];
